import { makeStyles } from "tss-react/mui"
import { ErrorView } from "./ErrorView"
import { AppErrorType } from "../../../core/api/errorTypes"
import { StandardDialog, StandardDialogProps } from "../dialogs/StandardDialog"

const useStyles = makeStyles()((theme) => ({
    dialog: {
        padding: theme.spacing(1),
    },
}))

type ErrorDialogProps = Pick<StandardDialogProps, "open"> &
    Readonly<{
        error: AppErrorType
        onClose: () => void
    }>

export function ErrorDialog({ error, open, onClose }: ErrorDialogProps) {
    const { classes } = useStyles()

    return (
        <StandardDialog open={open} onClose={onClose} slotProps={{ paper: { className: classes.dialog } }}>
            <ErrorView title={error.title} code={error.code} onClose={onClose} />
        </StandardDialog>
    )
}
